<template>
  <div class="container">
    <div style="margin: 10px 10px 10px 10px;">
      <el-row>
        <el-col :span="6">
          <el-input placeholder="Search" v-model="filters[0].value"></el-input>
        </el-col>
      </el-row>
    </div>

    <data-tables
      :data="tableData"
      :pagination-props="{ pageSizes: [15, 25, 50] }"
      :filters="filters"
      :table-props="tableProps"
    >
      <el-table-column label="商店ID" prop="id" sortable="custom" min-width="20px">
        <template slot-scope="scope">{{scope.row.accountId || scope.row.id}}</template>
      </el-table-column>
      <el-table-column label="商店SHOP ID" prop="shopId" sortable="custom" min-width="20px">
        <template slot-scope="scope">{{scope.row.shopId}}</template>
      </el-table-column>
      <el-table-column label="商店名稱" prop="name" sortable="custom" min-width="30px">
        <template slot-scope="scope">{{scope.row.name}}</template>
      </el-table-column>
      <el-table-column label="商店統編" prop="invoice" sortable="custom" min-width="30px">
        <template slot-scope="scope">{{scope.row.invoice}}</template>
      </el-table-column>

      <el-table-column label="Actions" min-width="20px">
        <template slot-scope="scope">
          <el-tooltip placement="top">
            <div slot="content">商店參數</div>
            <n-button type="info" size="sm" icon @click.native="clickInfo(scope.row)">
              <i class="now-ui-icons users_single-02"></i>
            </n-button>
          </el-tooltip>
          <el-tooltip placement="top">
            <div slot="content">修改商店設定</div>
            <n-button type="success" size="sm" icon @click.native="clickEdit(scope.row)">
              <i class="now-ui-icons ui-2_settings-90"></i>
            </n-button>
          </el-tooltip>
          <el-tooltip placement="top">
            <div slot="content">桌號QRCode管理</div>
            <n-button type="warn" size="sm" icon @click.native="clickQR(scope.row)">
              <font-awesome-icon icon="qrcode" />
            </n-button>
          </el-tooltip>
          <el-tooltip placement="top">
            <div slot="content">營業公休設定</div>
            <n-button
              type="default"
              style="background:#A25DDC;"
              size="sm"
              icon
              @click.native="openingSetting(scope.row)"
            >
              <i class="now-ui-icons ui-1_calendar-60"></i>
            </n-button>
          </el-tooltip>
          <el-tooltip placement="top">
            <div slot="content">串接設定與加值服務</div>
            <n-button
              type="danger"
              style="background:#386109;"
              size="sm"
              icon
              @click.native="middlewareSetting(scope.row)"
            >
              <i class="now-ui-icons business_globe"></i>
            </n-button>
          </el-tooltip>
          <el-tooltip placement="top">
            <div slot="content">接單機使用者管理</div>
            <n-button
              type="danger"
              style="background:#BA0000;"
              size="sm"
              icon
              @click.native="showQcposUsers(scope.row)"
            >
              <font-awesome-icon icon="tablet-alt" />
            </n-button>
          </el-tooltip>
          <el-tooltip placement="top">
            <div slot="content">外送條件設定</div>
            <n-button
              type="default"
              style="background:#f56042;"
              size="sm"
              icon
              @click.native="logisticsConf(scope.row)"
            >
              <i class="now-ui-icons shopping_delivery-fast"></i>
            </n-button>
          </el-tooltip>
          <el-tooltip placement="top">
            <div slot="content">發送商店資訊郵件</div>
            <n-button type="warning" size="sm" icon @click.native="sendEmail(scope.row)">
              <i class="now-ui-icons ui-1_email-85"></i>
            </n-button>
          </el-tooltip>

          <el-tooltip placement="top">
            <div slot="content">更新OA</div>
            <n-button type="warn" style="background:rgb(54, 209, 234);" size="sm" icon @click.native="updateOA(scope.row)">
              <font-awesome-icon icon="people-arrows" />
            </n-button>
          </el-tooltip>
          <el-tooltip placement="top">
            <div slot="content">訂單限流設定</div>
            <n-button
              type="warn"
              style="background:#6600cc;"
              size="sm"
              icon
              @click.native="orderLimit(scope.row)"
            >
              <font-awesome-icon icon="utensils" />
            </n-button>
          </el-tooltip>
          <el-tooltip placement="top">
            <div slot="content">權限管理</div>
            <n-button
              type="warn"
              style="background:#FF3636;"
              size="sm"
              icon
              @click.native="accessSetting(scope.row)"
            >
              <font-awesome-icon icon="lock" />
            </n-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </data-tables>
    <el-dialog
      :title="'接單機介面 - 使用者管理｜' + dialogs.qcposUsers.shop.name"
      width="40%"
      :visible.sync="dialogs.qcposUsers.show"
    >
      <PosUserMngmt
        user-type="si"
        :shop-id="dialogs.qcposUsers.shop.accountId"
      />
    </el-dialog>
  </div>
</template>

<script>
import { Table, TableColumn, Select } from "element-ui";
import { fetchShops, fetchSiAccounts } from "src/javascripts/si/fetchData";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faQrcode } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faQrcode);

import { DataTables, DataTablesServer } from "vue-data-tables";
import axios from "axios";
import moment from "moment";
import PosUserMngmt from "src/pages/QcPos/PosUserMngmt";

export default {
  components: {
    "font-awesome-icon": FontAwesomeIcon,
    DataTables,
    DataTablesServer,
    [Select.name]: Select,
    PosUserMngmt,
  },
  beforeRouteEnter(to, from, next) {
    fetchShops()
      .then(res => {
        console.log("res: ", res);
        next(vm => vm.setData(res));
      })
      .catch(err => {
        console.log("err: ", err);
      });
  },
  data() {
    return {
      dialogs: {
        qcposUsers: {
          show: false,
          shop: { id: -1, name: "" }
        },
      },
      tableData: [],
      filters: [
        {
          prop: ["id", "shopId", "name", "invoice"],
          value: ""
        }
      ],
      titles: [
        // {
        //   prop: "id",
        //   label: "商店ID"
        // },
        // {
        //   prop: "name",
        //   label: "商店名稱"
        // },
        // {
        //   prop: "siAccountName",
        //   label: "所屬SI"
        // }
        // {
        //   prop: "info",
        //   label: "Info"
        // }
      ],
      siAccounts: [],
      tableProps: {
        defaultSort: {
          prop: "id",
          order: "descending"
        }
      }
    };
  },
  created: function() {

  },
  methods: {
    setData: function(res) {
      console.log('the res data ' + JSON.stringify(res.data));
      this.tableData = res.data.map(d => {
        return {
          name: d.name,
          info: d.storeInfo,
          id: d.id,
          accountId: d.accountId,
          siAccountName: d.siAccountName,
          siAccountId: d.siAccountId,
          shopId: d.shopId,
          invoice: d.invoice,
          businessId:d.businessId
        };
      });
    },
    clickInfo: function(row) {
      let routeUrl = this.$router.resolve({ path: `/si/business/${row.id}/info`, query: { siAccountId: row.siAccountId } }); 
      window.open(routeUrl.href, '_blank'); 
    },
    clickEdit: function(row) {
      let routeUrl = this.$router.resolve({ path: `/si/business/${row.id}/edit` }); 
      window.open(routeUrl.href, '_blank'); 
      
    },
    clickDel: function() {
      console.log("del clicked!");
    },
    clickQR: function(row) {
      let routeUrl = this.$router.resolve({ path: `/si/business/${row.id}/qr`}); 
      window.open(routeUrl.href, '_blank'); 
    },
    orderLimit(row) {
      let routeUrl = this.$router.resolve({ path: `/si/business/${row.accountId}/order-limits`}); 
      window.open(routeUrl.href, '_blank'); 
    },
    accessSetting(row){
      console.log('row', row.accountId, row.businessId)
      let routeUrl = this.$router.resolve({ path: `/si/business/${row.accountId}/acls`});
      //let routeUrl = this.$router.resolve({ path: `/si/business/acls?business_id=${row.businessId}`}); 
      window.open(routeUrl.href, '_blank'); 
    },
    sendEmail: function(row) {
      let routeUrl = this.$router.resolve({ path: `/account-email?shop_id=${row.accountId}&shop_name=${row.name}`}); 
      window.open(routeUrl.href, '_blank'); 
    },
    openingSetting: function(row) {
      let qs = `shop_id=${row.accountId}&shop_name=${encodeURIComponent(
        row.name
      )}`;
      let routeUrl = this.$router.resolve({ path: `/opening?${qs}`}); 
      window.open(routeUrl.href, '_blank'); 
    },
    middlewareSetting: function(row) {
      let qs = `shop_id=${row.accountId}&shop_name=${encodeURIComponent(
        row.name
      )}`;
      let routeUrl = this.$router.resolve({ path: `/posmws?${qs}`}); 
      window.open(routeUrl.href, '_blank'); 
    },
    logisticsConf: function(row) {
      let qs = `shop_id=${row.accountId}&shop_name=${encodeURIComponent(
        row.name
      )}`;
      let routeUrl = this.$router.resolve({ path: `/logistics?${qs}`}); 
      window.open(routeUrl.href, '_blank'); 
    },
    goToOrderList(row) {
      let routeUrl = this.$router.resolve({ path: `/summary/orders?shopId=${row.accountId}`}); 
      window.open(routeUrl.href, '_blank'); 
    },
    updateOA: function(row) {
      let routeUrl = this.$router.resolve({ 
        path: `/si/business/${row.id}/update-oa`,
        query: { siAccountId: row.siAccountId, type: 'catering' }
       }); 
      window.open(routeUrl.href, '_blank'); 
    },
    showQcposUsers(row) {
      this.dialogs.qcposUsers.show = true;
      this.dialogs.qcposUsers.shop = row;
    },
  }
};
</script>